module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADDSURBVHgB7dTtCcIwEMbxG8ERHMFR3MCO0BHcwBE6iiM4Qkfwo6AJjznlTLSJVHoJCPeHQFtKf31JQ2RZlnRFH8aGmuYwhIHHAHbUpBRthr+jXXjVXX38E5Wq4iU04r0+nkMvWIftI3kcXufdsNfD+cI51GNMjg/6OD9VGR2T7SnucaJFAassyvu8gDicJ/hzxissLjlUKuFVUclhm/3mVVEp/Z8X43FyfUcj3uvgfCGenXNQKc5qxe89t19u1LKsv+0OfKFRAItQ63QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/index2.png
// module id = lwdB
// module chunks = 1